import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import pdf from "../../Assets/anass-bouchfar.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {
  

 

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Web Developer Freelancer, Laravel & VueJs (Fiverr)"
              date="03-2020 / Present"
              content={[
                "API",
              "Web applications", 
              "CMS",
              "Database conception"]}
            />
              <Resumecontent
              title="Web Developer, ASP.NET"
              date="04-2019 / 06-2019"
              content={["Design and Production of a Web Stock Management Application",
              "C#, ASP.NET, Entity Framework, MVC, SQL SERVER",
              "HTML5, Bootstrap, JQquery"

              ]}
            />
          
            <Resumecontent
              title="IT Support, National Office of Railways ONCF"
              date="07-2018 / 08-2018"
              content={["Help Desk"]}
            />
             <h3 className="resume-title">CERTIFICATES</h3>
            <Resumecontent
              href={[
                "https://www.coursera.org/account/accomplishments/verify/9JC93H7QS3RA?utm_medium=certificate&utm_source=link&utm_campaign=copybutton_certificate",
                `https://drive.google.com/file/d/18p0IDUtYpMXFUqGPjZxjgJqmw98dhW-D/view`,
                "https://www.credly.com/badges/7b72a58e-90d0-4fac-a991-e6890e575d59/linked_in",
                "https://www.credly.com/badges/b2526d13-2c10-4e5f-a98d-6219c2fb75e0/linked_in",
                "https://www.coursera.org/account/accomplishments/verify/KSMT7C9G6DX3?utm_medium=certificate&utm_source=link&utm_campaign=copybutton_certificate",
                "https://drive.google.com/file/d/1KE6BSIwzkM9FjDQQ-1CzWTwD_MD3NZ5W/view",
                "https://www.coursera.org/account/accomplishments/specialization/certificate/79FDKWH39T9R",
                "https://www.coursera.org/account/accomplishments/certificate/46ERPDJ9Z9RP",
                "https://www.credly.com/badges/d6b141ca-850c-4beb-b417-ff85349d6cb0/linked_in_profile",
                "https://drive.google.com/file/d/17_-UhYPZEnf2O1fvDI2wDEJzBBwkAGz7/view"
              ]}
              title=""
              content={[
                `Machine Learning (04/2020), Stanford University / Coursera `,
                `HCIA-AI, Huawei`,
                "Data Science Professional Certificate, IBM / Coursera",
                "Docker Essentials, IBM Digital - Nation",
                "Neural Networks and Deep Learning, deeplearning.ai / Coursera",
                "ReactJS and Redux, Bright Coding",
                "Applied Data Science, IBM / Coursera",
                "Internet Connection: How to Get Online?, CISCO / Coursera",
                "Databases and SQL for Data Science, IBM / Coursera",
                "The Online Marketing Fundamentals, Digital Marketing Google Certification"
              ]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="National School of Computer Science and System Analysis, ENSIAS"
              date="2021 - 2024"
              content={["Business Intelligence & Analytics Engineer, BI&A"]}
            />
            <Resumecontent
              title="National Institute of Statistics and Applied Economics, INSEA"
              date="2020 - 2021"
              content={["Master 1 of Information Systems and Intelligent Systems, M2SI"]}
            />
            <Resumecontent
              title="Faculty of Sciences, Ibn Tofail University"
              date="2016 - 2020"
              content={["Bachelor of Mathematical and Computer Science, SMI"]}
            />
            <Resumecontent
              title="Allal El Fassi High School"
              date="2015 - 2016"
              content={["baccalaureate Mathematical Sciences A"]}
            />
           
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
          <AiOutlineDownload />&nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
